import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Download, Check } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferBlock() {
  return <section id="oferta" className="py-24 bg-cream-dark/50 relative overflow-hidden" data-id="element-89">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-white/40 blur-3xl rounded-full pointer-events-none" data-id="element-90"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-91">
        <FadeIn data-id="element-92">
          <div className="bg-white rounded-[3rem] shadow-soft p-8 md:p-16 border border-white text-center" data-id="element-93">
            <h2 className="text-3xl md:text-5xl font-bold text-brown-dark mb-6" data-id="element-94">
              Recupera tus noches de sueño
            </h2>
            <p className="text-xl text-brown/80 font-serif mb-10" data-id="element-95">
              Transforma tus noches en solo 48 horas.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-12" data-id="element-96">
              <div className="text-center" data-id="element-97">
                <span className="text-sm font-bold text-accent uppercase tracking-wider mb-2 block" data-id="element-98">
                  Precio Especial
                </span>
                <div className="text-2xl text-brown/50 line-through mb-1" data-id="element-99">
                  $15
                </div>
                <div className="text-6xl md:text-7xl font-bold text-brown-dark font-serif" data-id="element-100">
                  $6,39
                </div>
              </div>

              <div className="text-left space-y-3" data-id="element-101">
                <div className="flex items-center gap-3" data-id="element-102">
                  <Check className="w-5 h-5 text-accent" data-id="element-103" />
                  <span className="text-brown-dark/80" data-id="element-104">
                    Acceso inmediato a la Guía
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-105">
                  <Check className="w-5 h-5 text-accent" data-id="element-106" />
                  <span className="text-brown-dark/80" data-id="element-107">
                    Todas las herramientas y plantillas
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-108">
                  <Check className="w-5 h-5 text-accent" data-id="element-109" />
                  <span className="text-brown-dark/80" data-id="element-110">
                    Bonus exclusivos incluidos
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center" data-id="element-111">
              <Button href="https://tumundoequilibrado.com/cart/51096956993831:1" onClick={trackAddToCart} icon={<Download className="w-5 h-5" data-id="element-113" />} className="w-full md:w-auto md:px-12 py-5 text-xl mb-4" data-id="element-112">
                Descarga tu guía ahora
              </Button>
              <p className="text-sm text-brown/60 font-medium" data-id="element-114">
                Descanso para ti y tu bebé comienza hoy mismo.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}